import { Ayah } from '@app-types/KuranTypes'
import LoadingSpinner from '@components/shared/Loading/Loading'
import { useUserData } from '@contexts/UserDataContext'
import { playMediaSafely } from 'utils/mediaPlayback'
import classNames from 'classnames'
import { Fragment, useRef } from 'react'
import Basmalah from './Basmalah'
import LearningQuranAyah from './LearningQuranAyah'

const QURAN_AUDIO_URL_BASE = 'https://audio.qurancdn.com/'
const QURAN_AYAH_URL_BASE = 'https://cdn.islamic.network/quran/audio/64/'
const QuranLearningMode = ({ ayahs }: { ayahs: Ayah[] }) => {
  const { userData } = useUserData()
  const audioElement = useRef<HTMLAudioElement>(null)

  const onTriggerWordPlay = (url: string, mode: 'ayah' | 'word' = 'word') => {
    if (!audioElement.current) return
    const urlToPlay =
      mode === 'ayah'
        ? `${QURAN_AYAH_URL_BASE}/ar.alafasy/${url}.mp3`
        : QURAN_AUDIO_URL_BASE + url
    audioElement.current.src = urlToPlay
    void playMediaSafely(audioElement.current, {
      onError: (error) => {
        console.error('Error playing learning mode audio:', error)
      },
    })
  }

  if (!ayahs) return <LoadingSpinner />

  const hideMeal = userData?.kuranMealType === 'hide'
  const hideTooltip = userData?.kuranTooltip === 'hide'
  return (
    <>
      <audio ref={audioElement} src="" />
      <div
        style={{
          direction: 'rtl',
        }}
        className={classNames(
          `flex select-none flex-wrap text-center dark:text-gray-300 md:justify-between`,
          userData.arabicFontFamily,
          {
            'justify-evenly': userData.arabicFontAlignment === 'middle',
          }
        )}
      >
        {ayahs.map((ayah, i) => {
          const isLastAyah = i === ayahs.length - 1
          return (
            <Fragment key={i}>
              {ayah.zero && <Basmalah i={i} ayah={ayah} />}

              {ayah.words_with_sound.map((word, index) => {
                const isAyahEnd = word.type === 'end'
                return (
                  <Fragment key={`${i}-${index}`}>
                    <LearningQuranAyah
                      {...{
                        isAyahEnd,
                        onTriggerWordPlay,
                        word,
                        hideMeal,
                        ayah,
                        hideTooltip,
                      }}
                    />
                    {(isLastAyah || ayah.surah.verse_count === ayah.verse_number) &&
                      isAyahEnd && (
                        <div key={`${i}-${index}-end`} className="no-height m-auto h-0">
                          &nbsp;
                        </div>
                      )}
                  </Fragment>
                )
              })}
            </Fragment>
          )
        })}
      </div>
    </>
  )
}

export default QuranLearningMode
